module.exports = __webpack_public_path__ + "img/skylight-logo.19c41685.jpg";